<script lang="ts" setup>
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const isOpen = ref<boolean>(false);
</script>

<template>
  <v-menu v-model="isOpen" :close-on-content-click="false" :min-width="250" location="top" offset="16">
    <template #activator="{ props: menuProps }">
      <div class="map-legend text-grey-darken-3" v-bind="menuProps">
        <v-icon class="mr-2" icon="mdi-map-legend" size="18"></v-icon>
        <span class="font-weight-500">{{ t("maps.legend") }}</span>
      </div>
    </template>

    <v-card class="rounded-lg">
      <v-card-text>
        <div class="position-relative">
          <span class="font-weight-500 text-grey-darken-3">{{ t("maps.legend") }}</span>

          <v-btn
            class="map-legend__close"
            color="grey-darken-2"
            density="comfortable"
            icon="mdi-close"
            size="md"
            variant="text"
            @click="isOpen = false"
          />

          <slot name="legend"></slot>
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<style lang="scss" scoped>
@import "@/assets/style/color";

.map-legend {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  background-color: $white;
  border: 1px solid $grey-lighten-2;
  border-radius: 16px;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);

  &:hover {
    background-color: $grey-lighten-5;
  }

  &__menu {
    min-width: 240px;
    position: relative;
  }

  &__close {
    position: absolute;
    top: 0;
    right: 0;
  }

  &__card-text {
    border-radius: 16px;
    border: 1px solid red;
  }
}
</style>
